module.exports = __webpack_public_path__ + "static/media/pattern.951b276d.jpg";